<template>
  <v-container :style="{  maxWidth: '1000px' }" class="mt-8">
    <h1>Metro Sets</h1>
    <p>
      MetroSets is a flexible web tool to visualize set systems using the metro map metaphor. Each element of the data set is represented by a station and lines connecting said stations model similarity between elements. By using this metaphor we leverage the familiarity of how to read and interpret metro maps. The 400 real-world metro maps show that the metaphor can potentially scale to display several hundred elements and dozens of sets.</p>
    <v-img src="../assets/home.png"/>
    <h2>The Technical Background</h2>
    <p>
      If you are interested in how the MetroSets system creates a metro map drawing of set data then take a look at the <router-link :to="{ name: 'poster'}">digital poster</router-link>.
    </p>
    <p>
      This tool was implemented to acompany a paper submission for IEEE Vis 2020. The paper can be found on <a href='https://arxiv.org/abs/2008.09367' target="_blank">arXiv</a>. The code is also available in our <a href='https://osf.io/nvd8e/' target="_blank">OSF repository</a>.
    </p>
    <h2>Get Started!</h2>
    <p>
      Get started by creating your first map. Either pick one of our example data sets and create a map, or take a look at an example file to understand the <a href="https://docs.google.com/spreadsheets/d/1AnVh7DBMA3cpXVNl1iduhOBVUlAAcSsE3m1EkE3q0kY/edit?usp=sharing">format requirement</a> to visualize your own data.
      <ul class="my-4">
        <li>
          <router-link :to="{ name: 'dataDetail', params: { dataId: '88e4bb02-88dd-4648-89ba-c3284e9f346f' }}">Simpsons</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'dataDetail', params: { dataId: '93749e07-dbf8-4643-a1fb-1e8f4c96b71a' }}">Magic: The Gathering</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'dataDetail', params: { dataId: '452ddcc3-abb2-4cf6-b7fd-fb7d8617b509' }}">Rock'n'Roll</router-link>
        </li>
      </ul>
    </p>
    <v-btn class="ma-2 textSecondary--text" tile color="secondary" :to="{ name: 'create'}">
      <v-icon left>mdi-subway-variant</v-icon>Create Your Own Map
    </v-btn>
  </v-container>
</template>

<script>

export default {
  name: 'Home'
}
</script>
